import { getDescriptions } from './getDescriptions';
import { addToArray } from './addToArray';
import { dateStr } from 'src/utils/dateStr';
/**
 * Takes a benefit information object and parses its data
 * into values that can be displayed.
 * @param {*} benefitInfo
 * @param {*} previousDesc
 * @returns
 */
export function getEbiObj(benefitInfo, previousDesc) {
  var ebiArray = [];
  const infoType = benefitInfo.infoType;
  var desc = getDescriptions(benefitInfo);
  var fullDescLabel = benefitInfo.infoTypeDescription;
  var fullDescValue = '';

  if (benefitInfo.timePeriod) {
    fullDescLabel += ' (' + benefitInfo.timePeriod + ')';
  }
  if (benefitInfo.inPlanNetworkDescription) {
    fullDescLabel += ' ' + benefitInfo.inPlanNetworkDescription;
  }
  if (benefitInfo.amount || benefitInfo.amount === 0) {
    fullDescValue = '$' + benefitInfo.amount;
  }
  if (benefitInfo.quantity || benefitInfo.quantityDescription) {
    fullDescValue +=
      ' ' + benefitInfo.quantity + benefitInfo.quantityDescription;
  }
  if (benefitInfo.percentage || benefitInfo.percentage === 0) {
    fullDescValue += benefitInfo.percentage * 100.0;
  }
  if (benefitInfo.authorizationCertificateRequiredDescription) {
    fullDescValue += benefitInfo.authorizationCertificateRequiredDescription;
  }
  //Splits the contact numbers up and if it was empty string the filter returns []
  //instead of [""]
  if (benefitInfo.relatedEntityContactNumbers) {
    for (const contactNumber in benefitInfo.relatedEntityContactNumbers
      .split('|')
      .filter(o => o)) {
      if (infoType === 'U' || infoType == 'R') {
        fullDescValue += ' ' + contactNumber;
      }
    }
  }

  addToArray(
    ebiArray,
    'Insurance Type',
    benefitInfo.insuranceTypeDescription,
    desc.insDesc && desc.insDesc != previousDesc.insDesc
  );
  addToArray(
    ebiArray,
    'Insurance Plan',
    benefitInfo.planCoverageDescription,
    desc.planDesc && desc.planDesc != previousDesc.planDesc
  );
  addToArray(
    ebiArray,
    'Coverage Level',
    benefitInfo.coverageLevelDescription,
    desc.covDesc && desc.covDesc != previousDesc.covDesc
  );
  addToArray(ebiArray, fullDescLabel, fullDescValue, true);
  addToArray(
    ebiArray,
    'Todo (finish): Procedure Code',
    benefitInfo.procedureCode,
    true
  );
  addToArray(ebiArray, 'Identifications', benefitInfo.identifications, true);
  // ARB-9084: highlighted UNCONDITIONALLY, because "Related Entities" is one of
  // the call-outs the ticket names and the reported miss (an air-transport bill)
  // was not a Medicare entity.
  //
  // Deliberately NOT gated on isMedicareSecondaryPayor: that helper is far
  // narrower (infoType 1/6/R with a fixed insuranceType set, OR infoType R +
  // relatedEntityType PRP + a name containing 'Medicare') and it drives the
  // widget's MSP *column*, not orange on this field. So this is a new behaviour
  // rather than widget parity — if it proves too noisy, narrowing it is a
  // product decision, not a bug fix.
  addToArray(
    ebiArray,
    'Related Entity Name',
    benefitInfo.relatedEntityName,
    true,
    true
  );
  addToArray(
    ebiArray,
    'Facility NPI',
    benefitInfo.facilityNpi,
    true
  );
  addToArray(
    ebiArray,
    'Facility Name',
    benefitInfo.facilityNpiName,
    true
  );
  
  addToArray(
    ebiArray,
    'Todo (finish): Related Entity Contact Numbers',
    benefitInfo.relatedEntityContactNumbers,
    infoType && infoType != 'U' && infoType != 'R'
  );
  addToArray(ebiArray, 'Messages', benefitInfo.messages, true);
  addToArray(ebiArray, "Coverage Dates", formatBenefitCoverageDates(benefitInfo.startDate, benefitInfo.endDate), benefitInfo.startDate || benefitInfo.endDate);
  addToArray(ebiArray, 'Related Entity Type', benefitInfo.relatedEntityTypeAsString, true);

  return ebiArray;
}

function formatBenefitCoverageDates(startDate, endDate){
  return `Effective Date: ${dateStr(startDate)}
          Expiration Date: ${dateStr(endDate)}`
}